import type { RouterProps } from 'wouter';
import { DashboardLayout } from 'components/Layout/DashboardLayout';
import { CreateInvoicePage } from 'components/pages/payments/CreateInvoicePage';
import { InvoiceDetailPage } from 'components/pages/payments/InvoiceDetailPage/index';
import { InvoicesListPage } from 'components/pages/payments/InvoicesListPage';
import { ProductListPage } from 'components/pages/payments/ProductListPage';
import { UserDetailPage } from 'components/pages/payments/UserDetailPage';
import { UsersListPage } from 'components/pages/payments/UsersListPage';
import { PaymentsHomePage } from 'components/pages/PaymentsHomePage/PaymentsHomePage';
import React, { Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';
import { usePaymentsApiHttpClientContext } from 'wrappers/PaymentsApiAuthProvider';
import { PlatformEntityProvider } from 'wrappers/PlatformEntityProvider';

import { DecodedParamsRoute } from './DecodedParamsRoute';

export const PaymentsRouter = ({
  hook,
  base,
  workspaceId,
}: Partial<RouterProps> & { workspaceId: string }): ReturnType<
  typeof Router
> => {
  const { hasWorkspace } = usePaymentsApiHttpClientContext();
  if (!hasWorkspace) {
    return (
      <DashboardLayout>
        <>Loading...</>
      </DashboardLayout>
    );
  }
  return (
    <PlatformEntityProvider>
      <DashboardLayout>
        <Suspense fallback={<>Loading...</>}>
          <Router hook={hook} base={base} key={base}>
            <Switch>
              <DecodedParamsRoute path="/users/:externalId">
                {(params) => (
                  <UserDetailPage
                    workspaceId={workspaceId}
                    externalId={params.externalId}
                  />
                )}
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/users">
                <UsersListPage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/invoices/:invoiceId">
                {(params) => (
                  <InvoiceDetailPage
                    workspaceId={workspaceId}
                    invoiceId={params.invoiceId}
                  />
                )}
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/invoices">
                <InvoicesListPage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/products">
                <ProductListPage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/create-invoice">
                <CreateInvoicePage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/">
                <PaymentsHomePage />
              </DecodedParamsRoute>
              <Route />
            </Switch>
          </Router>
        </Suspense>
      </DashboardLayout>
    </PlatformEntityProvider>
  );
};
